export function memberName(node, name, member, lastName) {
    if (node.classList && node.classList.contains("sub-name")) {
        const cleanName = name.replace("*", "").split(" ");
        const memberId = node.id.split("_")[2];
        member["member-id"] = memberId;
        member["individual-photo-url"] =
            `/media/uploads/photos/members/${memberId}.jpg`;
        if (name) {
            member["non-member"] = name.indexOf("*") > -1 ? "N" : "Y";
            member["first-name"] = cleanName[0];
            member["last-name"] = cleanName[1] || lastName;
        }
    }
}
